const NUMBER_PATTERN = /^-?\d*\.?\d*$/;

const normalizeNumberInput = (raw: string): string => {
  return (raw || '').toString().trim().replace(",", ".");
};

export const isValidPartialNumber = (raw: string): boolean => {
  const normalized = normalizeNumberInput(raw);
  if (normalized === '') return false;
  if (['.', '-', '-.'].includes(normalized)) return false;
  return NUMBER_PATTERN.test(normalized);
};

export const parseTolerantNumber = (raw: string | undefined | null): number | undefined => {
  const normalized = normalizeNumberInput(raw || '');
  if (!isValidPartialNumber(normalized)) return undefined;
  const parsed = parseFloat(normalized);
  return isNaN(parsed) ? undefined : parsed;
};

export const parseTolerantInt = (raw: string | undefined | null): number | undefined => {
  const parsed = parseTolerantNumber(raw);
  return parsed === undefined ? undefined : Math.round(parsed);
};
